'use client';

import { useUserProfile } from '@/context/UserProfileContext';
import { IonIcon, IonRouterLink } from '@ionic/react';
import { t } from 'i18next';
import { cameraOutline, happyOutline } from 'ionicons/icons';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { GolfAvatar } from './ui/GolfAvatar';
import { postEventService } from '@/services/PostEventService';

export function WhatsUp() {
  const { profile } = useUserProfile();

  if (!profile) return null;

  return (
    <>
      <Card className="space-y-4 p-4 hidden md:block">
        <div className="flex items-center gap-2">
          <IonRouterLink routerLink={`/u/${profile.username}`} slot="start">
            <GolfAvatar
              imageUrl={profile.imageUrl!}
              username={profile.username}
              name={profile.name}
              size={42}
            />
          </IonRouterLink>
          <Button
            onClick={() => postEventService.emit('openCreatePostModal', {})}
            variant="ghost"
            className="flex-1 justify-start px-4 bg-secondary text-muted-foreground"
          >
            <span>{t('create_new_post')}</span>
          </Button>
        </div>

        <div className="grid grid-cols-3">
          <Button onClick={() => postEventService.emit('openCreatePostModal', {})} variant="ghost" className="flex w-fit items-center gap-2 hover:bg-secondary font-semibold">
            <IonIcon icon={cameraOutline} className="size-5 text-green-500" />
            <span>{t('photos')}/{t('videos')}</span>
          </Button>
          <Button onClick={() => postEventService.emit('openCreatePostModal', {})} variant="ghost" className="flex w-fit items-center gap-2 hover:bg-secondary font-semibold">
            <IonIcon icon={happyOutline} className="size-5 text-yellow-500" />
            <span>{t('MGP:mood')}</span>
          </Button>
        </div>
      </Card>
    </>
  );
}
